import React from 'react';

export default class StaffMemberAssignedText extends React.Component {
    render() {
        var {assignedStaffMember} = this.props;
        if(! assignedStaffMember) {
            return (<span> No one assigned </span>);
        }

        return (<span>{` ${assignedStaffMember.firstName} ${assignedStaffMember.lastName} `}</span>);
    }
}


// WEBPACK FOOTER //
// ./app/components/clients/StaffMemberAssignedText.js